import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector, createSelector } from 'reselect';
import { getFormValues } from 'redux-form';
import objectPath from 'object-path';

import {
    submittedPayment as adyenSubmittedPayment,
    savedPaymentData as adyenSavedPaymentData,
} from 'ggApp/modules/adyen/selectors';
import * as adyenActions from 'ggApp/modules/adyen/actions';
import { COMMON_FORM_NAME } from 'ggApp/modules/adyen/constants';

import { reduxForm } from 'ggApp/modules/form/selectors';

import FormWrap from './FormWrap';

const enhance = compose(
    connect(
        createStructuredSelector({
            adyenSubmittedPayment,
            adyenSavedPaymentData,
            formValues: createSelector(
                getFormValues(COMMON_FORM_NAME, reduxForm),
                (formValues) => ({
                    number: objectPath.get(formValues, 'cardNumber', ''),
                    name: objectPath.get(formValues, 'holderName', ''),
                    expiry: objectPath.get(formValues, 'expiry', ''),
                    cvc: objectPath.get(formValues, 'cvc', ''),
                }),
            ),
        }),
        (dispatch) => ({
            adyenActions: bindActionCreators(adyenActions, dispatch),
        }),
    ),
);

export default enhance(FormWrap);
